// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkCellTask } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { isNotNil } from 'helpers/isNotNil';
import { getDisplayNameWO } from 'modules/Shop/WorkOrders/WorkOrderDetail/common';

type Props = {
  workCellTask?: WorkCellTask;
  opened: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

const CompleteFinalTaskModalContent = ({ workCellTask }: Pick<Props, 'workCellTask'>) => (
  <>
    <Text>
      Completing this task will finalize and move{' '}
      <b>{isNotNil(workCellTask) ? getDisplayNameWO(workCellTask) : 'this work order'}</b> to complete. Do you want to
      continue?
    </Text>
    <Text fz="sm">Note: Adjusted time cannot be changed when the work order is in completed status.</Text>
  </>
);

export const CompleteFinalTaskModal = ({ workCellTask, opened, onClose, onConfirm }: Props) => (
  <WrappedModal
    title="Complete task"
    opened={opened}
    onClose={onClose}
    onConfirm={onConfirm}
    confirmationText="Complete task"
  >
    <CompleteFinalTaskModalContent workCellTask={workCellTask} />
  </WrappedModal>
);
